export default __webpack_public_path__ + "static/media/alert-svgrepo-com.a1049108.svg";